//This functions checks whether element text (content from API), is bigger or not than the max-hight of parent container
export const checkIfScrollable = (element: HTMLElement, maxHeightInPx: number): boolean => {
    //scrollHeight is always in px
    return element.scrollHeight > maxHeightInPx;
};
